import { whyUsIcons } from "../config/landingPageIcons";

export default function WhyUs({ section, items = [] }) {
  if (!section || section.is_enabled === 0) return null;

  return (
    <section className="why-us section section--alt" id="why-us" aria-label="Why choose us">
      <div className="section__inner">
        <div className="section__header">
          {section.badge && <span className="section__tag">{section.badge}</span>}
          <h2 className="section__title">{section.title}</h2>
          {section.subtitle && <p className="section__subtitle">{section.subtitle}</p>}
        </div>

        <div className="why-us__grid">
          {items.map((item) => (
            <div key={item.id} className="feature-card">
              <span className="feature-card__icon" aria-hidden="true">{whyUsIcons[item.extra?.icon] || whyUsIcons.mentors}</span>
              <h3 className="feature-card__title">{item.title}</h3>
              <p className="feature-card__desc">{item.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
